import { render, staticRenderFns } from "./Admin.vue?vue&type=template&id=63d27e3c&scoped=true&lang=pug&"
import script from "./Admin.vue?vue&type=script&lang=js&"
export * from "./Admin.vue?vue&type=script&lang=js&"
import style0 from "./Admin.vue?vue&type=style&index=0&id=63d27e3c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d27e3c",
  null
  
)

export default component.exports